export enum AppMode {
  APP_MODE = 'app_mode',
  RECRUITER_MODE = 'recruiter',
  CANDIDATE_MODE = 'candidate',
}

export const getAppMode = () => localStorage.getItem(AppMode.APP_MODE);
export const setAppMode = (mode: string) => localStorage.setItem(AppMode.APP_MODE, mode);
export const clearAppMode = () => localStorage.removeItem(AppMode.APP_MODE);
